import React from 'react';
import { createRoot } from 'react-dom/client';

import App from './App';

// TODO: MHO - možná by bylo fajn mít zapnutý StrictMode (přísnější hlídání věcí), ale console logy zdvojeně plevelily konzoli, ještě prozkoumat tu možnost
createRoot(document.getElementById('root') as HTMLElement).render(
    // <React.StrictMode>
    <App />
    // </React.StrictMode>
);
